import * as React from 'react'
import Drawer from '@mui/material/Drawer'

import { IconButton, Typography, Box, Badge, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { icons } from '../../../../../../../../utils/icons'
import { useStyles } from './style'
import { LoadingButton } from '@mui/lab'

type Anchor = 'top' | 'left' | 'bottom' | 'right'

export const FiltersFloat = ({ children, cleanFilter, count, right, top, m, searchButton,title }: any) => {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  })

  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
      return
    }

    setState({ ...state, [anchor]: open })
  }

  const styles = useStyles()
  
  const { t } = useTranslation()

  return (
    <div>
      {(['right'] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <Badge badgeContent={count} color="primary" sx={[styles.iconFilter, { right, top }]}>
            <Tooltip title={t('ToolTips.filters')}>
              <IconButton onClick={toggleDrawer(anchor, true)}>{icons('filter')}</IconButton>
            </Tooltip>
          </Badge>

          <Drawer
            PaperProps={{
              sx: { width: '35%', padding: '20px', minWidth: '520px' },
            }}
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            <Typography variant="title" fontWeight="bold" marginBottom={2}>{title}</Typography>

            {children}

            <Box sx={styles.actions} {...m ?? {}}>
              <Box>
                {count > 0 && (
                  <Typography variant="body1" sx={styles.cleanFilters} onClick={cleanFilter}>
                    {t('general.cleanFilters')}
                  </Typography>
                )}
              </Box>

              <LoadingButton loading={!!searchButton.loading} disabled={searchButton.disabled} onClick={searchButton.onClick} variant='contained'>{t("general.searchUsers")}</LoadingButton>

              {/* <Button onClick={toggleDrawer(anchor, false)} variant="contained">
                Se supone que es el de buscar
              </Button> */}
            </Box>
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  )
}
